import { render, staticRenderFns } from "./downIos.vue?vue&type=template&id=2a61d400&scoped=true"
import script from "./downIos.vue?vue&type=script&lang=js"
export * from "./downIos.vue?vue&type=script&lang=js"
import style0 from "./downIos.vue?vue&type=style&index=0&id=2a61d400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61d400",
  null
  
)

export default component.exports